import { render } from "./HelpAssistance.vue?vue&type=template&id=c3bb6df0"
const script = {}

import "./HelpAssistance.vue?vue&type=style&index=0&id=c3bb6df0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__